import React from "react"

export default function MapLoading() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        background: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Inter, sans-serif",
        fontSize: 16,
        fontWeight: 500,
        color: "#888",
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 9999,
      }}>
      Loading map...
    </div>
  )
}
